import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  QaiButtonComponent,
  QaiDialogComponent,
  QaiIconComponent,
} from '@qai/ui';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { firstValueFrom } from 'rxjs';
import { AuthorService } from 'src/app/services/self-serve/author.service';
import { SimulationConstants } from 'src/app/utils/constants/self-serve/simulation.constants';
import { AuthorReactiveFormService } from '../../../services/author-reactive-form.service';

@Component({
  selector: 'publish-simulation-modal',
  standalone: true,
  templateUrl: './publish-simulation-modal.component.html',
  styleUrls: ['./publish-simulation-modal.component.scss'],
  imports: [
    FormsModule,
    CommonModule,
    QaiDialogComponent,
    QaiButtonComponent,
    QaiIconComponent,
    TranslocoModule,
  ],
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: 'simulationBuilder' }],
})
export class PublishSimulationModalComponent implements OnInit {
  @ViewChild('dialog') dialogRef: QaiDialogComponent | undefined;
  @Input('open') open: boolean = false;
  /** Knowledge Checks can't be published yet, so confirming only closes the modal. */
  @Input() isKnowledgeCheck: boolean = false;
  callUuid: string = '';

  @Output() confirm = new EventEmitter<void>();
  @Output() closeModal = new EventEmitter<void>();

  form!: FormGroup;
  networkRequestInProgress: boolean = false;
  baseForm!: FormGroup;

  constructor(
    private router: Router,
    private authorService: AuthorService,
    private route: ActivatedRoute,
    private authorReactiveFormService: AuthorReactiveFormService
  ) {}

  ngOnInit(): void {
    this.callUuid = this.route.snapshot.paramMap.get('uuid') || '';
  }

  private async loadForm(): Promise<void> {
    this.baseForm = await firstValueFrom(
      this.authorReactiveFormService.getForm(this.callUuid)
    );
    this.form = this.baseForm.get(
      SimulationConstants.CALL_PERSONA_PATH
    ) as FormGroup;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open']?.currentValue) {
      this.showModal();
      if (!this.form) this.loadForm();
    }
  }

  handleConfirm(): void {
    if (this.isKnowledgeCheck) {
      this.hideModal();
      return;
    }
    if (!this.callUuid) {
      console.warn('Call UUID is missing.');
      return;
    }
    this.networkRequestInProgress = true;

    this.publishSimulation();
  }

  publishSimulation() {
    const moduleUuid =
      this.baseForm?.get(SimulationConstants.MODULE_UUID_PATH)?.value || '';
    this.authorService.publishSimulation(this.callUuid, moduleUuid).subscribe({
      next: (res: any) => {
        console.log('Publish successful:', res);
        this.router.navigate(['/self-serve']);

        this.hideModal();
      },
      error: (err: any) => {
        console.error('Publish failed:', err);
      },
    });
  }

  handleClose() {
    this.closeModal.emit();
  }

  hideModal() {
    if (this.dialogRef) {
      this.dialogRef.close();
      this.networkRequestInProgress = false;
    }
  }

  showModal() {
    if (this.dialogRef) {
      this.dialogRef.showModal();
    }
  }
}
